import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import ConstData from "../../../lib/ConstData";

import Alerts from "../../etc/list/Alerts";

const FindPWCertifyPhone = ({ isExistUserInfo, handleSelectedFunc, isPhoneTestOK, isPhoneTestStart, alertKind, alertMessage }) => {
    const { t } = useTranslation();

    const timer = useRef();

    const [phoneNumber, setPhoneNumber] = useState("");
    const [certiCode, setCertiCode] = useState("");
    const [isAliveCertifyTime, setIsAliveCertifyTime] = useState(false);
    const [certifyTime, setCertifyTime] = useState(0);
    const [lIsPhoneTestOK, setIsPhoneTestOK] = useState(isPhoneTestOK);
    const [lIsPhoneTestStart, setIsPhoneTestStart] = useState(isPhoneTestStart);

    const [lAlertKind, setAlertKind] = useState(alertKind);
    const [lAlertMessage, setAlertMessage] = useState(alertMessage);

    useEffect(() => {
        if (lIsPhoneTestStart && !isAliveCertifyTime) {
            handleSelectedFunc({ selectedFunc: "FALSE_TO_PHONE_CHECK_SEND", message: t("인증번호_재발급_안내", { ns: "user" }) });
        }
    }, [isAliveCertifyTime]);

    useEffect(() => {
        if (certifyTime > 0) {
            timer.current = setInterval(() => {
                setCertifyTime(c => c - 1);
            }, 1000);
        } else {
            if (certifyTime === -1) {

            } else if (certifyTime === -2) {
                handleSelectedFunc({ selectedFunc: "FLASE_TO_PHONE_CHECK_OK", message: t("휴대폰_번호_변경_알림", { ns: "user" }) });
            } else {
                setIsAliveCertifyTime(false);
            }
        }
        if (timer.current !== null) {
            return () => clearInterval(timer.current);
        }
    }, [certifyTime]);

    useEffect(() => {
        setAlertKind(alertKind);
    }, [alertKind]);

    useEffect(() => {
        if (lAlertKind !== alertKind) {
            setAlertKind(alertKind);
        }
        setAlertMessage(alertMessage);
    }, [alertMessage]);

    useEffect(() => {
        if (isPhoneTestStart) {
            setCertifyTime(120);
            setIsAliveCertifyTime(true);
        }
        setIsPhoneTestStart(isPhoneTestStart);
    }, [isPhoneTestStart]);

    useEffect(() => {
        if (isPhoneTestOK) {
            setCertifyTime(-1);
        }
        setIsPhoneTestOK(isPhoneTestOK);
    }, [isPhoneTestOK]);

    useEffect(() => {
        if (isPhoneTestOK || isPhoneTestStart) {
            setCertifyTime(-2);
        }
    }, [phoneNumber]);

    const onChangePhoneNumber = (e) => {
        handleSelectedFunc({ selectedFunc: "MESSAGE", message: "phoneCertification" });
        let str = autoHypenPhoneNumber(e.target.value);
        setPhoneNumber(str);
        // setPhoneNumber(e.target.value);
    }

    const onChangeCertiCode = (e) => {
        let str = e.target.value;
        str = str.replace(/[^0-9]/g, "");
        setCertiCode(str);
    }

    const checkCertiCodeValue = (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, "");
    }

    const checkPhoneNumber = () => {
        if (phoneNumber === "" || phoneNumber === "" || phoneNumber === null) {
            setAlertKind(ConstData.ALERT_KIND.DANGER);
            setAlertMessage(t("유효성_검사_휴대폰_번호_입력오류", { ns: "user" }));
        } else {
            handleSelectedFunc({ selectedFunc: "GET_CERTI", phoneNumber });
        }
    }

    const clickCertifyCode = () => {
        if (certiCode === "" || certiCode === "" || certiCode === null) {
            setAlertKind(ConstData.ALERT_KIND.DANGER);
            setAlertMessage(t("유효성_검사_인증번호_입력오류", { ns: "user" }));
        } else {
            handleSelectedFunc({ selectedFunc: "CONFIRM_CERTI", code: certiCode });
        }
    }


    const autoHypenPhoneNumber = (str) => {
        str = str.replace(/[^0-9]/g, "");
        var tmp = "";

        if (str.length < 4) {
            return str;
        } else if (str.length < 7) {
            tmp += str.substr(0, 3);
            tmp += "-";
            tmp += str.substr(3);
            return tmp;
        } else if (str.length < 11) {
            tmp += str.substr(0, 3);
            tmp += "-";
            tmp += str.substr(3, 3);
            tmp += "-";
            tmp += str.substr(6);
            return tmp;
        } else {
            tmp += str.substr(0, 3);
            tmp += "-";
            tmp += str.substr(3, 4);
            tmp += "-";
            tmp += str.substr(7);
            return tmp;
        }
    }

    const getDisp = () => {
        const ss = certifyTime % 60;
        const mm = Math.floor(certifyTime / 60);

        const str_s = "0" + parseInt(ss).toString();
        const str_m = "0" + parseInt(mm).toString();

        const str_time = str_m.substr(str_m.length - 2, 2) + ":" + str_s.substr(str_s.length - 2, 2);

        return str_time;
    }

    return (
        <div className="d-flex flex-column align-items-center justify-content-center my-2 area-80">
            <div className="d-flex flex-column font-md py-4 px-2 w-100">
                {
                    isExistUserInfo ?
                        <>
                            <div className="d-flex align-items-center justify-content-center mb-2">
                                <input className="d-flex mr-1" type="radio" name="findIdRadios" id="defaultRadio" defaultChecked value="ID" />
                                {t("회원정보_찾기_안내_문구_2", { ns: "user" })}
                            </div>
                            <div className="input-area">
                                <div className="input-data align-items-center">
                                    <input type="text" maxLength={13} id="findPwPn" className="d-flex flex-fill web-search-input mr-2 wmin-50" placeholder={t("유효성_검사_휴대폰_번호_입력오류", { ns: "user" })} onChange={onChangePhoneNumber} value={phoneNumber} />
                                    <button type="button" className="btn btn-sm btn-primary m-0 px-2 fit-content" onClick={() => checkPhoneNumber()}>
                                        {t("인증번호_전송", { ns: "user" })}
                                    </button>
                                    {
                                        !lIsPhoneTestOK && lIsPhoneTestStart && isAliveCertifyTime &&
                                        <span className="text-center red-text small ml-2">
                                            {getDisp()}
                                        </span>
                                    }
                                </div>
                            </div>
                            <div className="input-area">
                                <div className="input-data align-items-center">
                                    {
                                        !lIsPhoneTestOK ?
                                            <input type="text" id="findPwCode" className="d-flex flex-fill web-search-input mr-2" placeholder={t("유효성_검사_인증번호_입력오류", { ns: "user" })} onChange={onChangeCertiCode} onKeyUp={checkCertiCodeValue} /> :
                                            <input type="text" id="findPwCode" className="d-flex flex-fill web-search-input mr-2" placeholder={t("유효성_검사_인증번호_입력오류", { ns: "user" })} disabled />
                                    }
                                    <button type="button" className="btn btn-sm btn-primary m-0 px-2" disabled={lIsPhoneTestStart === true ? false : true} onClick={clickCertifyCode}>
                                        {t("인증번호_확인", { ns: "user" })}
                                    </button>
                                </div>
                            </div>
                            <Alerts kind={lAlertKind} message={lAlertMessage} />
                        </> :
                        <span className="small">
                            {t("회원정보_찾기_안내_문구_1", { ns: "user" })}
                        </span>
                }
            </div>
            <div className="d-flex w-100 justify-content-center">
                {
                    isExistUserInfo ?
                        <>
                            <button className="btn btn-sm hiclasstv-grey px-3" onClick={() => handleSelectedFunc({ selectedFunc: "PRE", step: ConstData.FIND_STEP.START })}>{t("이전", { ns: "common" })}</button>
                            <button className="btn btn-sm btn-primary px-4" onClick={() => handleSelectedFunc({ selectedFunc: "RESET_PW", phoneNumber: phoneNumber })} disabled={isPhoneTestOK === true ? false : true}>{t("다음", { ns: "common" })}</button>
                            <button className="btn btn-sm hiclasstv-grey px-3" onClick={() => handleSelectedFunc({ selectedFunc: "CLOSE" })}>{t("취소", { ns: "common" })}</button>
                        </> :
                        <>
                            <button className="btn btn-sm hiclasstv-grey px-3" onClick={() => handleSelectedFunc({ selectedFunc: "PRE", step: ConstData.FIND_STEP.START })}>{t("이전", { ns: "common" })}</button>
                            {/* <button className="btn btn-sm btn-primary px-4" onClick={() => handleSelectedFunc({ selectedFunc: "REGIST_TOGGLE" })}>회원가입</button> */}
                            <button className="btn btn-sm hiclasstv-grey px-3" onClick={() => handleSelectedFunc({ selectedFunc: "CLOSE" })}>{t("취소", { ns: "common" })}</button>
                        </>
                }
            </div>
        </div>
    );
}

export default FindPWCertifyPhone;